import { render, staticRenderFns } from "./TopicFilter.vue?vue&type=template&id=5e4c9761&"
import script from "./TopicFilter.ts?vue&type=script&lang=ts&"
export * from "./TopicFilter.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports